module.exports = __webpack_public_path__ + "static/media/bff6.18aaaeb2.png";